import alertRuleSensorTypes from './alertRuleSensorTypes.json';
import alerts from './alerts.json';
import bulkPauseUnpause from './bulkPauseUnpause.json';
import common from './common.json';
import login from './login.json';
import partners from './partners.json';

export default {
  alertRuleSensorTypes,
  alerts,
  bulkPauseUnpause,
  common,
  login,
  partners,
};
